import { render, staticRenderFns } from "./BulkRegistration.vue?vue&type=template&id=1881702d&scoped=true"
import script from "./BulkRegistration.vue?vue&type=script&lang=js"
export * from "./BulkRegistration.vue?vue&type=script&lang=js"
import style0 from "./BulkRegistration.vue?vue&type=style&index=0&id=1881702d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1881702d",
  null
  
)

export default component.exports